import type { RenewalEmailKind } from "./RenewalSendTestEmailModal";

/**
 * Default button label per membership email ("" = no button). Must match
 * `defaultRenewalCtaLabel` in backend/src/services/renewalEmailCopy.service.ts:
 * saving the default text stores "follow the default".
 */
export const DEFAULT_RENEWAL_CTA_LABELS: Record<RenewalEmailKind, string> = {
  instructions: "Renew membership",
  overdue: "Renew membership",
  expired: "Renew membership",
  success: "View your membership",
  cancelled: "",
  custom: "",
};
